const $inject = ['$rootScope', '$timeout', '$scope', '$routeParams', '$http', 'dataService', 'lbaLeafletMapService'];

const lbaLatLongMapSearch = function ($rootScope, $timeout, $scope, $routeParams, $http, dataService, lbaLeafletMapService) {
  const vm = this;
  vm.latSettings = vm.settings.latField;
  vm.longSettings = vm.settings.longField;
  vm.radiusSettings = vm.settings.radiusField;
  vm.isImperialSystem = vm.settings.IsImperialSystemField;
  vm.additionalPlots = vm.settings.additionalPlots;

  const latDataLookUp = dataService.spiltDataAt(vm.latSettings.dataAt, $routeParams);
  const longDataLookUp = dataService.spiltDataAt(vm.longSettings.dataAt, $routeParams);
  const radiusDataLookUp = dataService.spiltDataAt(vm.radiusSettings.dataAt, $routeParams);
  const isImperialSystemDataLookUp = dataService.spiltDataAt(vm.isImperialSystem.dataAt, $routeParams);
  const additionalPlotsLookUp = vm.additionalPlots ? dataService.spiltDataAt(vm.additionalPlots.dataAt, $routeParams) : '';

  vm.searchForAddress = searchForAddress;
  vm.viewLatLongOnMap = viewLatLongOnMap;
  vm.setLatLong = setLatLong;
  vm.mapLocations = [];
  vm.addressLookUp = '';
  vm.showMap = false;

  $timeout(viewLatLongOnMap, 1000);

  function getLat() {
    return _.get(dataService.data.activeItem, latDataLookUp)
  }

  function getLong() {
    return _.get(dataService.data.activeItem, longDataLookUp)
  }

  function getRadius() {
    return _.get(dataService.data.activeItem, radiusDataLookUp)
  }

  function getIsImperialSystem() {
    return _.get(dataService.data.activeItem, isImperialSystemDataLookUp)
  }

  function getAdditionalPlots() {
    const hotelIds = _.get(dataService.data.activeItem, additionalPlotsLookUp);
    getHotels(hotelIds);
  }

  function getHotels(hotelIds) {
    if (vm.mapLocations.length > 0) {
      vm.mapLocations = vm.mapLocations[0].Name ? [] : [vm.mapLocations[0]];
    }

    if (_.isArray(hotelIds) && hotelIds.length) {
      let ids = '';

      hotelIds.forEach((id) => {
        ids = ids.concat(`ids=${id}&`);
      });

      $http.get(`${endPointUrl}/api/v2/Hotels/HotelsByExternalIds?${ids}`).then(res => {
        vm.mapLocations = vm.mapLocations.concat(res.data.Result);
        refresh();
      });
    } else {
      refresh();
    }
  }

  function viewLatLongOnMap() {
    vm.showMap = true;

    let long = getLong();
    let lat = getLat();
    getAdditionalPlots();

    if (long === null || lat === null || long === undefined || lat === undefined) {
      return
    }

    vm.markerOverride = true;

    const radius = getRadius();
    if (radius) {
      vm.radius = {
        radius: getIsImperialSystem() ? radius * 1609.344 : radius * 1000,
        lat: lat,
        long: long,
        text: `Latitude: ${lat}, Longitude: ${long}`
      };
    }

    refresh();
  }

  function searchForAddress(address) {
    if (!address) {
      return;
    }
    vm.radius = null;
    vm.markerOverride = {text: address, ctaText: 'Set as Lat/Long'};
    lbaLeafletMapService.getPosByAddress(address)
      .then(data => {
        vm.mapLocations = [
          {
            Longitude: data.long,
            Latitude: data.lat
          }
        ];

        refresh();
      });
  }

  function setLatLong() {
    _.set(dataService.data.activeItem, latDataLookUp, vm.mapLocations[0].Latitude);
    _.set(dataService.data.activeItem, longDataLookUp, vm.mapLocations[0].Longitude);
    $rootScope.$broadcast(vm.latSettings.dataAt, {refreshData: true});
    $rootScope.$broadcast(vm.longSettings.dataAt, {refreshData: true});
    vm.mapLocations = [];
    viewLatLongOnMap();
  }

  function refresh() {
    $timeout(() => {
      $rootScope.$emit('leaflet.refresh', vm.refreshMap);
    });
  }

};

lbaLatLongMapSearch.$inject = $inject;

export default lbaLatLongMapSearch;


// WEBPACK FOOTER //
// ./src/components/lbaLatLongMapSearch/lbaLatLongMapSearchCtrl.js